import { jsx, jsxs } from 'react/jsx-runtime';
import { Content as Content$1 } from '@radix-ui/react-dialog';
import { useRouter } from '@fabric-app/compat';
import { keyframes, styled, css } from 'styled-components';
import { useQueryResourceAssets } from '../../queries/useQueryResourceAssets.js';
import { getRouteParamAsString } from '@fabric-app/utils/url/routing';
import { isResourceNotionNotepad } from '../../../resources/utils/resourceDetailGuards.js';
import { useHandleOpenAssetsPanel } from './useOpenAssetsPanel.js';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { Button } from '@fabric-app/ui/components/Button';
import { ScrollArea } from '@fabric-app/ui/components/ScrollArea';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { EmbedSimpleView } from '../../../Tiptap/Extensions/EmbedResource/PreviewComponent/PreviewSimple.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { IconNavigational24LeftChevron } from '@fabric-app/icons/svg';

const NotepadAssetsPanel = ({ resource, isFullscreen }) => {
  const queryAssets = useQueryResourceAssets({
    resourceId: resource.id
  });
  const router = useRouter();
  const query = router.query;
  const [showAssetsPanel] = getRouteParamAsString(query, [
    "showAssetsPanel"
  ]);
  const isNotionItem = isResourceNotionNotepad(resource);
  const handleOpenAssetsPanel = useHandleOpenAssetsPanel();
  const handleClose = () => handleOpenAssetsPanel(false);
  return /* @__PURE__ */ jsx(Modal.Root, {
    open: showAssetsPanel === "true",
    onOpenChange: () => handleOpenAssetsPanel(false),
    children: /* @__PURE__ */ jsx(Modal.Portal, {
      children: /* @__PURE__ */ jsxs(ModalContent, {
        isFullscreen,
        children: [
          /* @__PURE__ */ jsx(TopBar, {
            children: /* @__PURE__ */ jsx(Button, {
              shape: "square",
              size: "xs",
              variant: "bg-tertiary",
              style: {
                height: 30,
                width: 30,
                fontSize: 11
              },
              onClick: handleClose,
              children: /* @__PURE__ */ jsx(IconNavigational24LeftChevron, {})
            })
          }),
          /* @__PURE__ */ jsx(ScrollArea.Default, {
            scrollbarVariant: "subtle",
            innerDisplayFlex: true,
            children: /* @__PURE__ */ jsxs(Content, {
              children: [
                queryAssets.isLoading && /* @__PURE__ */ jsx(Flex, {
                  style: {
                    padding: "4rem"
                  },
                  alignItems: "center",
                  children: /* @__PURE__ */ jsx(Spinner, {})
                }),
                queryAssets.data?.data?.assets?.map((asset) => {
                  return /* @__PURE__ */ jsx(ItemWrap, {
                    children: /* @__PURE__ */ jsx(EmbedSimpleView, {
                      dropdownMenuPosition: "inside",
                      containerStyle: {
                        width: "100%"
                      },
                      title: asset.name || "Untitled",
                      extension: asset.extension,
                      resourceId: asset.id,
                      kind: asset.kind,
                      fileSize: asset.size,
                      hideDropdownMenu: isNotionItem
                    })
                  }, asset.id);
                })
              ]
            })
          })
        ]
      })
    })
  });
};
const slideIn = keyframes([
  `from{transform:translateX(-100%);opacity:0;}to{transform:translateX(0);opacity:1;}`
]);
const slideOut = keyframes([
  `from{transform:translateX(0);opacity:1;}to{transform:translateX(-100%);opacity:0;}`
]);
const ModalContent = styled(Content$1).withConfig({
  displayName: "NotepadAssetsPanel__ModalContent",
  componentId: "sc-33ff06d7-0"
})([
  `background:`,
  `;z-index:126;position:fixed;top:0;height:100%;width:260px;max-width:90%;border-right:1px solid `,
  `;padding-top:env(safe-area-inset-top);&[data-state='open']{animation:`,
  ` 0.1s ease-out;}&[data-state='closed']{animation:`,
  ` 0.1s ease-out;}`,
  ` `,
  `{padding-top:0;top:calc(env(safe-area-inset-top) + 64px);width:300px;&[data-state='open']{animation:`,
  ` 0.2s ease-out;}&[data-state='closed']{animation:`,
  ` 0.2s ease-out;}}`
], cssVar["color-bg-primary"], cssVar["color-border-primary"], slideIn, slideOut, ({ isFullscreen }) => isFullscreen && css([
  `top:69px;`
]), mediaMobile, slideIn, slideOut);
const TopBar = styled(Flex).attrs({
  justifyContent: "flex-end",
  alignItems: "center"
}).withConfig({
  displayName: "NotepadAssetsPanel__TopBar",
  componentId: "sc-33ff06d7-1"
})([
  `padding:0 6px;padding-top:6px;`
]);
const Content = styled(Flex).attrs({
  direction: "column",
  overflow: "hidden"
}).withConfig({
  displayName: "NotepadAssetsPanel__Content",
  componentId: "sc-33ff06d7-2"
})([
  `padding:0 6px;padding-bottom:calc(6px + env(safe-area-inset-bottom));`
]);
const ItemWrap = styled.div.withConfig({
  displayName: "NotepadAssetsPanel__ItemWrap",
  componentId: "sc-33ff06d7-3"
})([
  `padding:4px 0;`
]);

export { NotepadAssetsPanel };
//# sourceMappingURL=NotepadAssetsPanel.js.map
